/* Microdacyn - add to cart without leaving the page.
   The product form is a plain {% form 'product' %}, which posts to /cart/add and lands
   the shopper on /cart. That throws away where they were browsing, so the submit is
   intercepted: add over AJAX, re-render the cart drawer section, open it. If anything
   goes wrong the normal form post still runs, so the shopper is never stuck.

   The same handler serves:
   - the one-click button on the product cards (form.mdc-card__form, CRO playbook 1.4)
   - the one-click button on the in-cart upsell (form.mdc-upsell__form, playbook 4.4)
   - the sticky buy bar, which submits the product form itself

   Each is a real form with a real action, so it also works with JavaScript off - it
   just reloads into /cart the way Shopify does by default.

   The upsell deliberately has its OWN class. It used to reuse mdc-card__form, which
   also carries the card's position:absolute - so the upsell's button was lifted out of
   its row and pinned to the bottom corner of the drawer, where nobody could see it. */
(() => {
  const SECTION_ID = 'cart-drawer-section';
  const HOST_ID = 'shopify-section-' + SECTION_ID;
  const FORMS = 'form.mdc-buy, form.mdc-card__form, form.mdc-upsell__form';

  /* header, footer and drawer all render the same .cart-bubble markup */
  const refreshBubbles = async () => {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const count = cart.item_count || 0;
      document.querySelectorAll('.cart-bubble').forEach((bubble) => {
        bubble.classList.toggle('visually-hidden', count === 0);
        const value = bubble.querySelector('.cart-bubble__text-count');
        if (!value) return;
        value.classList.toggle('hidden', count === 0);
        value.textContent = count > 99 ? '99+' : String(count);
      });
    } catch (e) {
      /* the drawer markup already carries the right count; the bubbles are cosmetic */
    }
  };

  const openDrawer = () => {
    const open = () => {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    };
    if (window.customElements && !customElements.get('theme-drawer')) {
      customElements.whenDefined('theme-drawer').then(() => requestAnimationFrame(open));
    } else {
      requestAnimationFrame(open);
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(FORMS)) return;
    /* no drawer on this template - let Shopify handle the post */
    if (!document.getElementById(HOST_ID)) return;

    /* On /cart the page itself is the cart, so after an upsell add the page is simply
       reloaded to show the new line - opening the drawer on top of the cart page would
       show the same thing twice. */
    const onCartPage = document.body.querySelector('[data-template="cart"]') !== null;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button && button.disabled) return;
    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
    }

    try {
      const body = new FormData(form);
      body.append('sections', SECTION_ID);
      body.append('sections_url', window.location.pathname);

      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'add failed');

      if (onCartPage) {
        window.location.reload();
        return;
      }

      const markup = data.sections && data.sections[SECTION_ID];
      const host = document.getElementById(HOST_ID);
      if (markup && host) {
        const fresh = new DOMParser().parseFromString(markup, 'text/html').getElementById(HOST_ID);
        if (fresh) host.replaceWith(fresh);
      }

      await refreshBubbles();
      openDrawer();
    } catch (error) {
      /* HTMLFormElement.submit() does not fire the submit event, so this cannot loop */
      form.submit();
      return;
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
})();

/* Microdacyn: maximum 10 bucati per produs pe comanda. Blocheaza adaugarea peste limita (pagina de produs, carduri, bara sticky, upsell) si afiseaza mesajul; in cos max-ul vine din snippets/quantity-selector.liquid. */
(() => { const LIM = 10; const M = 'Poți comanda maximum 10 bucăți din acest produs. Pentru cantități mai mari, contactează-ne la office@pharma1.ro și îți trimitem o ofertă personalizată.'; const cart = {}; const load = async () => { try { const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); Object.keys(cart).forEach((k) => delete cart[k]); c.items.forEach((i) => { cart[i.variant_id] = (cart[i.variant_id] || 0) + i.quantity; }); } catch (e) {} }; const msg = (a, on) => { let m = a.nextElementSibling; const has = !!m && m.classList.contains('mdc-qty-limit'); if (on && !has) { m = document.createElement('p'); m.className = 'mdc-qty-limit'; m.setAttribute('role', 'alert'); m.textContent = M; m.style.cssText = 'margin:6px 0 0;font-size:13px;line-height:1.4;color:#b42318;'; a.insertAdjacentElement('afterend', m); } else if (!on && has) { m.remove(); } }; const toast = () => { let t = document.getElementById('mdc-qty-toast'); if (!t) { t = document.createElement('div'); t.id = 'mdc-qty-toast'; t.setAttribute('role', 'alert'); t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;width:max-content;max-width:min(92vw,520px);background:#fff;color:#b42318;border:1px solid #f1c0bb;border-radius:12px;padding:12px 16px;font-size:14px;line-height:1.4;box-shadow:0 8px 24px rgba(0,0,0,.15);'; t.textContent = M; document.body.appendChild(t); } clearTimeout(t._h); t.hidden = false; t._h = setTimeout(() => { t.hidden = true; }, 7000); }; const run = () => { document.querySelectorAll('quantity-selector-component, cart-quantity-selector-component').forEach((c) => { const i = c.querySelector('input[type="number"]'); if (!i || typeof c.getEffectiveMax !== 'function') return; const a = c.closest('.cart-items__quantity-controls') || c.parentElement; const e = c.getEffectiveMax(); msg(a, Number(i.max) === LIM && e !== null && Number(i.value) >= e); }); document.querySelectorAll('form.mdc-buy').forEach((f) => { const i = f.querySelector('input[name="quantity"]'); const id = f.querySelector('[name="id"]'); if (!i || !id) return; const room = Math.max(1, LIM - (cart[id.value] || 0)); i.max = room; if (Number(i.value) > room) i.value = room; msg(i.closest('.mdc-qty') || i, Number(i.value) >= room); }); }; const later = () => { setTimeout(run, 0); setTimeout(async () => { await load(); run(); }, 700); }; ['click', 'focusout', 'change', 'input'].forEach((t) => document.addEventListener(t, later, true)); document.addEventListener('cart:update', later); document.addEventListener('submit', (ev) => { const f = ev.target; if (!(f instanceof HTMLFormElement) || !f.matches('form.mdc-buy, form.mdc-card__form, form.mdc-upsell__form')) return; const id = f.querySelector('[name="id"]'); if (!id) return; const qi = f.querySelector('[name="quantity"]'); const q = Number(qi ? qi.value : 1) || 1; if ((cart[id.value] || 0) + q > LIM) { ev.preventDefault(); ev.stopImmediatePropagation(); const box = f.querySelector('.mdc-qty'); if (box) { run(); msg(box, true); } toast(); } else { setTimeout(async () => { await load(); run(); }, 1500); } }, true); load().then(run); })();
